import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  private platformType: 'ios' | 'android' | 'web' = 'web';

  constructor(private iab: InAppBrowser) {
    if (typeof cordova !== 'undefined') {
      this.platformType = /Android/i.test(navigator.userAgent) ? 'android' : 'ios';
    } else {
      this.platformType = 'web';
    }
  }

  get isNativePlatform(): boolean {
    return this.platformType === 'ios' || this.platformType === 'android';
  }

  openURL(url: string): void {
    if (!this.isNativePlatform) {
      window.open(url, '_blank');
      return;
    } else {
      const options: InAppBrowserOptions = {
        location: 'yes',         
        toolbar: 'yes',          
        closebuttoncaption: 'Cerrar', 
        toolbarposition: 'top',
        hidden: 'no',           
        zoom: 'no',              
        hardwareback: 'yes',     
        fullscreen: 'yes'
      };
    
      const browser = this.iab.create(url, '_blank', options);
    
      browser.on('exit').subscribe(() => {});
    }
  }

}
